import { defineMessages } from 'react-intl';

export const benefitsModalMessages = defineMessages({
  header: {
    id: 'pd.benefits.modal.header',
    defaultMessage: 'Vaše oblíbené značky a kategorie se slevou',
  },
});
